export default __webpack_public_path__ + "static/gplay-15d9b98795e6b5a55777168f04d67c47.svg";